import React from "react";
import Classes from "./styles/style.module.css";
import HintIcon from "../../images/icons/hintIcon.png";

const Hint = ({ hintText }) => {
  return (
    <div className={Classes.hintContainer}>
      <img src={HintIcon} alt="hintIcon" />
      <p dangerouslySetInnerHTML={{__html:hintText}}></p>
    </div>
  );
};

export default Hint;
